var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-container",on:{"click":_vm.close}},[_c('div',{staticClass:"main",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_vm._t("default"),_c('div',{staticClass:"safe-area"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }